import {
  TKwikUIProgressBarSize,
  VKwikUIProgressBarSize
} from "./progress-bar.definitions";

export const isValidKeyValue = (key: string, value: any): boolean => {
  const isNumber = (x: number) => typeof x === "number";
  const isStringArray = (x: string | string[]) =>
    typeof x === "string" || Array.isArray(x);
  const isBoolean = (x: boolean) => typeof x === "boolean";

  const methods = {
    color: isStringArray,
    isShowLabel: isBoolean,
    max: isNumber,
    size: (x: TKwikUIProgressBarSize) => VKwikUIProgressBarSize.includes(x),
    value: isNumber
  };

  return methods[key] && methods[key](value);
};
